class ProductSticky extends HTMLElement {
  onVariantChangeUnsubscriber = undefined
  raf = 0

  static mainAddToCartButton() {
    return document.querySelector(
      'product-info product-form [type="submit"][name="add"]'
    )
  }

  connectedCallback() {
    this._boundUpdate = this._scheduleUpdate.bind(this)
    this.mainButton = ProductSticky.mainAddToCartButton()

    if (this.mainButton) {
      window.addEventListener('scroll', this._boundUpdate, { passive: true })
      window.addEventListener('resize', this._boundUpdate, { passive: true })
      this._updateVisibility()
    } else {
      requestAnimationFrame(() => {
        this.mainButton = ProductSticky.mainAddToCartButton()
        if (!this.mainButton) return
        window.addEventListener('scroll', this._boundUpdate, { passive: true })
        window.addEventListener('resize', this._boundUpdate, { passive: true })
        this._updateVisibility()
      })
    }

    this.onVariantChangeUnsubscriber = subscribe(
      PUB_SUB_EVENTS.optionValueSelectionChange,
      this.handleOptionValueChange.bind(this)
    )
  }

  disconnectedCallback() {
    if (this._boundUpdate) {
      window.removeEventListener('scroll', this._boundUpdate)
      window.removeEventListener('resize', this._boundUpdate)
    }
    if (this.raf) cancelAnimationFrame(this.raf)
    this.onVariantChangeUnsubscriber?.()
  }

  _scheduleUpdate() {
    if (this.raf) return
    this.raf = requestAnimationFrame(() => {
      this.raf = 0
      this._updateVisibility()
    })
  }

  _updateVisibility() {
    const button = this.mainButton || ProductSticky.mainAddToCartButton()
    if (!button) return
    if (button.offsetParent === null) return

    const sticky = document.querySelector('product-sticky')
    if (!sticky) return

    const rect = button.getBoundingClientRect()
    const atPageTop = window.scrollY < 4
    const mainButtonAboveViewport = rect.bottom < 0
    const mainButtonBelowViewport = rect.top > window.innerHeight
    // Only after user has scrolled down past the main CTA; never when the CTA
    // is still below the fold (below- viewport) and never when at the top of the page
    const shouldShow =
      !atPageTop && !mainButtonBelowViewport && mainButtonAboveViewport

    if (shouldShow) {
      sticky.classList.remove('-translate-y-full')
      sticky.classList.add('shadow-xl')
      sticky.classList.add('pointer-events-auto')
    } else {
      sticky.classList.add('-translate-y-full')
      sticky.classList.remove('shadow-xl')
      sticky.classList.remove('pointer-events-auto')
    }
  }

  handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
    if (!this.contains(event.target)) return
  }
}

customElements.define('product-sticky', ProductSticky)
